import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar'
import VuetifyConfirm from 'vuetify-confirm'

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#00adcd',
        secondary: '#5b3e97',
        accent: '#8c9eff',
        error: '#c21e51'
      }
    }
  }
})

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
})

Vue.use(VuetifyToast, {
  x: 'center',
  y: 'top',
  $vuetify: vuetify.framework
})

Vue.use(VuetifyConfirm, { vuetify })

export default vuetify
